var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import { asSliceSelectors } from '../types';
var SLICE_NAME = 'ABTest';
var initialState = {
    features: {
        'smf-102__progressive_disclosure': false,
        'smf-650__block_own_advisory_flow': false,
    },
};
var rawSlice = createSlice({
    name: SLICE_NAME,
    initialState: initialState,
    reducers: {},
});
var selectors = asSliceSelectors({
    getAllFeatures: function (state) { return state[SLICE_NAME].features; },
    isProgressiveDisclosureEnabled: function (state) {
        return !!state[SLICE_NAME].features['smf-102__progressive_disclosure'];
    },
});
export var ABTestSlice = {
    name: SLICE_NAME,
    actions: __assign({}, rawSlice.actions),
    selectors: selectors,
};
export default rawSlice.reducer;
